import {
  GET_LIST_THUCHIHOPDONG,
  GET_LIST_THUCHIHOPDONG_SUCCESS,
  GET_LIST_THUCHIHOPDONG_FAILURE,
} from "./actionTypes";

export const getListThuChiHopDong = (dataSearch) => ({
  type: GET_LIST_THUCHIHOPDONG,
  dataSearch,
});

export const getListThuChiHopDongSuccess = (data) => ({
  type: GET_LIST_THUCHIHOPDONG_SUCCESS,
  payload: data,
});

export const getListThuChiHopDongFailure = () => ({
  type: GET_LIST_THUCHIHOPDONG_FAILURE,
});
